import type {} from "@/common/types/notesTemplates";
import type {
  CreateRecordingRequestBody,
  CreateRecordingResponseData,
  CreateVisitRequestBody,
  CreateVisitResponseData,
} from "@/common/types/visits";
import axiosClient from "@/lib/axios/axiosClient";

export const createVisit = async (
  body: CreateVisitRequestBody
): Promise<CreateVisitResponseData> => {
  const response = await axiosClient.post<CreateVisitResponseData>(
    "/visits",
    body,
    {
      sendToken: true,
    }
  );
  return response.data;
};

export const createRecording = async (
  body: CreateRecordingRequestBody
): Promise<CreateRecordingResponseData> => {
  const response = await axiosClient.post<CreateRecordingResponseData>(
    `/visits/${body.fileId}/recordings`,
    body,
    {
      sendToken: true,
    }
  );

  return response.data;
};
